import { FC } from 'react';
import { EasyField } from 'react-bootstrap-formutil';

interface WeakNetworkPromptProps {
    type: 'loading' | 'error';
    name: string;
    errorText?: string;
}

// 弱网情况下的一些提示, 很多地方会用到, 所以提取一个公共组件
const WeakNetPrompt: FC<WeakNetworkPromptProps> = ({ type, errorText, name }) => {
    const curName = `temporary_${name}_${type}`;
    const curErrorText = errorText
        ? errorText
        : type === 'loading'
        ? __('正在获取数据, 请等待...')
        : __('获取数据出错, 请重试');

    return (
        <EasyField
            key={curName}
            name={curName}
            type="hidden"
            $defaultValue={false}
            checker={value => !!value || curErrorText}
        />
    );
};

export default WeakNetPrompt;
